module.exports = __webpack_public_path__ + "img/biometric_parameters.524fb419.svg";